import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperKey } from '~/store/flippers/types'
import { StateFlippers } from './reducer'

type StateFlipperKey = keyof StateFlippers

type FlipperResponseMap = Record<FlipperKey, StateFlipperKey>

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.SSO_TWO_FA_AUTHENTICATOR]: 'isSsoTwoFaAuthenticatorEnabled',
  [FLIPPER_KEYS.STRAITSX_DPT_CHANGEOVER]: 'isDptApplied',
  [FLIPPER_KEYS.STRAITSX_DPT_RISK_MODAL]: 'isDptRiskModalEnabled',
  [FLIPPER_KEYS.STRAITSX_ENABLE_FAZZ_VA_FOR_DASHBOARD]: 'isFazzVaForDashboardEnabled',
  [FLIPPER_KEYS.STRAITSX_ENABLE_FAZZ_VA_FOR_DIRECT_MINT]: 'isFazzVaForDirectMintEnabled',
  [FLIPPER_KEYS.STRAITSX_TRAVEL_RULE_ADDR_WHITELISTING]: 'isTravelRuleAddrWhitelistingEnabled',
  [FLIPPER_KEYS.STRAITSX_TRAVEL_RULE_DEPOSIT_DECLARATION]: 'isTravelRuleDepositDeclarationEnabled',
  [FLIPPER_KEYS.USDC_MATIC_DEPOSIT]: 'isUsdcMaticDepositEnabled',
  [FLIPPER_KEYS.USDC_MATIC_WITHDRAWAL]: 'isUsdcMaticWithdrawalEnabled',
  [FLIPPER_KEYS.USDT_BEP20_DEPOSIT]: 'isUsdtBep20DepositEnabled',
  [FLIPPER_KEYS.USDT_BEP20_UI]: 'isUSDTBEP20UIEnabled',
  [FLIPPER_KEYS.USDT_BEP20_WITHDRAWAL]: 'isUsdtBep20WithdrawalEnabled',
  [FLIPPER_KEYS.USDT_DASHBOARD_TRON_UI]: 'isTronUIEnabled',
  [FLIPPER_KEYS.USDT_TRON_DEPOSIT]: 'isUsdtTrc20DepositEnabled',
  [FLIPPER_KEYS.USDT_TRON_WITHDRAWAL]: 'isUsdtTrc20WithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_ARB_DEPOSIT]: 'isXsgdArbDepositEnabled',
  [FLIPPER_KEYS.XSGD_ARB_WITHDRAWAL]: 'isXsgdArbWithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_AVAX_DEPOSIT]: 'isXsgdAvaxDepositEnabled',
  [FLIPPER_KEYS.XSGD_AVAX_WITHDRAWAL]: 'isXsgdAvaxWithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_ARBITRUM_UI]: 'isArbitrumUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_AVALANCHE_UI]: 'isAvalancheUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_ETHEREUM_UI]: 'isEthereumUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_HEDERA_UI]: 'isHederaUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_POLYGON_UI]: 'isPolygonUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_RIPPLE_UI]: 'isRippleUIEnabled',
  [FLIPPER_KEYS.XSGD_DASHBOARD_ZILLIQA_UI]: 'isZilliqaUIEnabled',
  [FLIPPER_KEYS.XSGD_ERC20_DEPOSIT]: 'isXsgdErc20DepositEnabled',
  [FLIPPER_KEYS.XSGD_ERC20_WITHDRAWAL]: 'isXsgdErc20WithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_HTS_DEPOSIT]: 'isXsgdHtsDepositEnabled',
  [FLIPPER_KEYS.XSGD_HTS_WITHDRAWAL_FEE_CHARGING]: 'isHtsWithdrawalFeeCharging',
  [FLIPPER_KEYS.XSGD_HTS_WITHDRAWAL]: 'isXsgdHtsWithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_MATIC_DEPOSIT]: 'isXsgdMaticDepositEnabled',
  [FLIPPER_KEYS.XSGD_MATIC_WITHDRAWAL]: 'isXsgdMaticWithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_XRP_DEPOSIT]: 'isXsgdXrpDepositEnabled',
  [FLIPPER_KEYS.XSGD_XRP_WITHDRAWAL]: 'isXsgdXrpWithdrawalEnabled',
  [FLIPPER_KEYS.XSGD_ZRC2_DEPOSIT]: 'isXsgdZrc2DepositEnabled',
  [FLIPPER_KEYS.XSGD_ZRC2_WITHDRAWAL]: 'isXsgdZrc2WithdrawalEnabled',
  [FLIPPER_KEYS.XUSD_BEP20_DEPOSIT_APP]: 'isXusdBep20DepositEnabled',
  [FLIPPER_KEYS.XUSD_BEP20_DEPOSIT_BIZ]: 'isXusdBep20DepositEnabled',
  [FLIPPER_KEYS.XUSD_BEP20_WITHDRAWAL_APP]: 'isXusdBep20WithdrawalEnabled',
  [FLIPPER_KEYS.XUSD_BEP20_WITHDRAWAL_BIZ]: 'isXusdBep20WithdrawalEnabled',
  [FLIPPER_KEYS.XUSD_DASHBOARD_BNBSMART_APP_UI]: 'isBnbsmartUIEnabled',
} as const
